export default {
    getAmbienceResources: { method: 'get', url: 'ambiences/resources' },
    postAmbienceResources: { method: 'post', url: 'ambiences/resources' },
    updateAmbienceResources: { method: 'put', url: 'ambiences/resources/{id}' },
    deleteAmbienceResources: { method: 'delete', url: 'ambiences/resources/{id}' },
}